import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/TransformerBushingsPowerTransmissionHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-31.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .rtb { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO (no border-top) ══ */
  .rtb-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .rtb-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .rtb-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .rtb-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .rtb-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .rtb-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .rtb-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .rtb-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .rtb-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .rtb-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .rtb-bc-item:hover { color: #EB2019; }
  .rtb-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .rtb-bc-sep img { width: 24px; height: 24px; display: block; }
  .rtb-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .rtb-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .rtb-main-section { padding: 80px 0 120px 0; }
  .rtb-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .rtb-article { flex: 1; min-width: 0; }

  .rtb-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .rtb-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .rtb-meta-item:last-child { border-right: none; padding-right: 0; }
  .rtb-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .rtb-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .rtb-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .rtb-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .rtb-article-body p { margin-bottom: 20px; }
  .rtb-article-body p:last-child { margin-bottom: 0; }

  .rtb-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  .rtb-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 0px 0; line-height: 160%; display: block;
  }

  /* Numbered ol list */
  .rtb-article-body ol {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
    counter-reset: rtb-counter;
  }
  .rtb-article-body ol li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: rtb-counter;
  }
  .rtb-article-body ol li::before {
    content: counter(rtb-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .rtb-article-body ol li > span { flex: 1; }

  /* Bullet ul list */
  .rtb-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .rtb-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .rtb-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .rtb-article-body ul li > span { flex: 1; }

  .rtb-article-body strong { font-weight: 600; color: #202020; }

  .rtb-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .rtb-red-link:hover { opacity: 0.8; }

  /* Hashtags */
  .rtb-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .rtb-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .rtb-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .rtb-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .rtb-nav-btn:hover { color: #EB2019; }
  .rtb-nav-btn img { width: 40px; height: 40px; display: block; }

  .rtb-share-icons { display: flex; align-items: center; gap: 20px; }
  .rtb-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .rtb-share-icon:hover { opacity: 0.85; }
  .rtb-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .rtb-sidebar { flex: 0 0 475px; }
  .rtb-sidebar-block { margin-bottom: 60px; }
  .rtb-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .rtb-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .rtb-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .rtb-recent-item:hover .rtb-recent-title { color: #EB2019; }
  .rtb-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .rtb-recent-body { flex: 1; min-width: 0; }
  .rtb-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .rtb-social-icons { display: flex; align-items: center; gap: 30px; }
  .rtb-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .rtb-social-icon:hover { opacity: 0.8; }
  .rtb-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .rtb-hero             { height: 350px; }
    .rtb-hero-content     { padding: 0 32px; }
    .rtb-hero-title       { font-size: 30px; }
    .rtb-hero-divider     { width: 100%; max-width: 479px; }
    .rtb-breadcrumb       { padding: 24px 0 0 0; }
    .rtb-breadcrumb-inner { padding: 0 32px; }
    .rtb-inner            { padding: 0 32px; }
    .rtb-main-section     { padding: 48px 0 60px 0; }
    .rtb-main-row         { flex-direction: column; gap: 48px; }
    .rtb-sidebar          { flex: none; width: 100%; }
    .rtb-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .rtb-hero             { height: 360px; }
    .rtb-hero-content     { padding: 0 16px; }
    .rtb-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .rtb-hero-divider     { width: 100%; }
    .rtb-hero-subtitle    { font-size: 14px; }
    .rtb-breadcrumb       { padding: 30px 0 0 0; }
    .rtb-breadcrumb-inner { padding: 0 16px; }
    .rtb-bc-item          { font-size: 14px; gap: 14px; }
    .rtb-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .rtb-bc-sep img       { width: 22px; height: 22px; }
    .rtb-inner            { padding: 0 16px; }
    .rtb-main-section     { padding: 30px 0 60px 0; }
    .rtb-main-row         { flex-direction: column; gap: 60px; }
    .rtb-sidebar          { flex: none; width: 100%; }
    .rtb-article-title    { font-size: 20px; margin-bottom: 15px; }
    .rtb-article-body     { font-size: 14px; }
    .rtb-article-body p   { margin-bottom: 15px; }
    .rtb-article-body ul  { margin: 0 0 20px 0; gap: 10px; }
    .rtb-article-body ol  { margin: 0 0 20px 0; gap: 10px; }
    .rtb-article-body ul li { font-size: 14px; }
    .rtb-article-body ol li { font-size: 14px; }
    .rtb-meta-item        { font-size: 14px; }
    .rtb-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .rtb-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .rtb-h3               { font-size: 14px; margin: 15px 0 0px 0; }
    .rtb-nav-btn img      { width: 24px; height: 24px; }
    .rtb-nav-btn          { font-size: 14px; }
    .rtb-share-icon img   { width: 34px; height: 34px; }
    .rtb-sidebar-title    { font-size: 20px; }
    .rtb-hashtags         { margin-top: 30px; }
  }
`;

const recentPosts = [
  {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function RoleTransformerBushingsSafePowerTransmission() {
  return (
    <div className="rtb">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="rtb-hero">
        <img className="rtb-hero-bg" src={HeroBgImg} alt="Transformer Bushings Power Transmission Hero" />
        <div className="rtb-hero-overlay" />
        <div className="rtb-hero-content">
          <h1 className="rtb-hero-title">
            The Role of Transformer Bushings in Ensuring Safe Power Transmission
          </h1>
          <hr className="rtb-hero-divider" />
          <p className="rtb-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="rtb-breadcrumb" aria-label="Breadcrumb">
        <div className="rtb-breadcrumb-inner">
          <a href="/" className="rtb-bc-item">Home</a>
          <span className="rtb-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="rtb-bc-item">News &amp; Updates</a>
          <span className="rtb-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="rtb-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="rtb-main-section">
        <div className="rtb-inner">
          <div className="rtb-main-row">

            {/* ── ARTICLE ── */}
            <article className="rtb-article">

              {/* Meta bar */}
              <div className="rtb-meta-bar">
                <span className="rtb-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="rtb-meta-item"><img src={CalendarIcon} alt="date" /> January 24, 2025</span>
                <span className="rtb-meta-item"><img src={ClockIconImg} alt="time" /> 6:55 am</span>
                <span className="rtb-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="rtb-article-title">
                The Role of Transformer Bushings in Ensuring Safe Power Transmission
              </h1>

              {/* Body */}
              <div className="rtb-article-body">

                <p>When thinking about power transmission, one probably thinks about massive transformers, high-voltage lines, and systems of intricate intricacies that work together in harmony to deliver electricity from vast power plants to the home or business. However, one crucial part rarely catches the average mind's eye: the <a href="/news/transformer-bushings-coal-power" className="rtb-red-link">transformer bushing</a>. Most unsung heroes are critical to efficiency and safety within power transmission systems.</p>

                {/* Article image */}
                <img className="rtb-article-img" src={ArticleImg} alt="Transformer Bushings Power Transmission" />

                <p>In this blog, we will review transformer bushings, why they are relevant, and how they ensure a faultless flow of electricity without raising security issues.</p>

                <span className="rtb-h2">Understanding Transformer Bushings?</span>

                <p>These are essential devices that insulate and support electrical conductors entering or leaving a grounded transformer enclosure. In other words, they block high-voltage currents from coming into contact with the transformer body. Without these bushings, the risk of short circuits, power outages, or catastrophic equipment failures would significantly increase.</p>

                <span className="rtb-h2">Are these Bushings Essential for Power Transmission Systems?</span>

                <p>These bushings are indispensable for multiple reasons:</p>

                <ol>
                  <li><span><strong>Electrical Insulation:</strong> They provide a barrier between live conductors and the grounded components of the transformer, preventing electrical discharges that could damage the equipment or cause accidents.</span></li>
                  <li><span><strong>Voltage Management:</strong> In high-voltage systems, bushings manage the safe transfer of electrical energy by minimizing power losses and avoiding voltage breakdowns.</span></li>
                  <li><span><strong>Operational Reliability:</strong> With durable and properly maintained bushings, transformers can operate reliably for decades, reducing downtime and ensuring a consistent power supply.</span></li>
                  <li><span><strong>Enhanced Safety:</strong> By keeping high-voltage currents isolated, bushings protect maintenance personnel and the surrounding infrastructure from potential hazards.</span></li>
                </ol>

                <span className="rtb-h2">Condenser-Type Bushings: Managing Electrical Stress</span>

                <p>Condenser-type bushings are engineered to manage the electrical stress distribution within high-voltage transformers. These bushings incorporate multiple conductive layers, known as capacitive grading, within the insulation material. This design ensures a uniform voltage gradient along the bushing, minimizing the risk of partial discharges and enhancing the overall dielectric performance. By effectively controlling the electric field, condenser-type bushings contribute to the longevity and reliability of transformer operations.</p>

                <span className="rtb-h2">Importance of Regular Maintenance and Monitoring</span>

                <p>Regular maintenance and monitoring of transformer bushings are crucial for preventing unexpected failures. Over time, factors such as thermal cycling, electrical stress, and environmental conditions can degrade the insulation properties of bushings. Implementing routine inspections, including visual assessments and diagnostic tests like Dissolved Gas Analysis (DGA), can detect early signs of deterioration. Proactive maintenance strategies not only extend the service life of bushings but also ensure the uninterrupted operation of the power transmission system.</p>

                <span className="rtb-h2">Integration of Advanced Monitoring Technologies</span>

                <p>The integration of advanced monitoring technologies, such as online bushing monitoring systems, has revolutionized the way transformer bushings are managed. These systems provide real-time data on parameters like capacitance, power factor, and leakage current, enabling predictive maintenance approaches. By continuously assessing the health of bushings, utilities can make informed decisions, schedule timely interventions, and avoid costly unplanned outages.</p>

                <span className="rtb-h2">Environmental Considerations and Material Advancements</span>

                <p>Environmental factors, including pollution, humidity, and temperature fluctuations, can significantly impact the performance of transformer bushings. To address these challenges, manufacturers have developed bushings with improved materials, such as resin-impregnated paper (RIP) and resin-impregnated synthetic (RIS) insulation systems. These materials offer superior resistance to moisture ingress and thermal aging, enhancing the bushings' durability in harsh operating conditions.</p>

                <span className="rtb-h2">Transformer Bushings Provide Safe Power Transmission</span>

                <p>Safe power transmission is critical to modern society, and transformer bushings are crucial in achieving this goal.</p>

                <span className="rtb-h2">Here's how:</span>

                <ul>
                  <li><span><strong>Minimizing Electrical Faults:</strong> Bushings withstand immense electrical stresses, significantly reducing the likelihood of arcing or short circuits.</span></li>
                  <li><span><strong>Temperature Resistance:</strong> The device is usually manufactured with porcelain, epoxy, or resin-impregnated paper and does not degrade in high or unusually low temperatures.</span></li>
                  <li><span><strong>Environmental Protection:</strong> Bushings protect the transformer's internal parts from the outside environment, possibly influenced by moisture, dust, and other contaminants, helping to perfect performance in harsh environments and conditions.</span></li>
                  <li><span><strong>Long-Term Reliability:</strong> Quality bushings are designed to last, reducing periodic replacements and minimizing long-term maintenance costs.</span></li>
                </ul>

                <span className="rtb-h2">Sustaining Transformer Bushings: A Proactive Strategy</span>

                <p>Routine maintenance and regular inspections are vital to ensure transformer bushings perform at their best.</p>

                <span className="rtb-h2">Critical maintenance practices include:</span>

                <ul>
                  <li><span><strong>Visual Inspections:</strong> Look for cracks, discoloration, or other signs of wear on the bushing's exterior.</span></li>
                  <li><span><strong>Electrical Testing:</strong> Perform diagnostic tests to monitor insulation resistance and identify potential weaknesses.</span></li>
                  <li><span><strong>Cleaning:</strong> Keep bushings clean and free of dirt or grime to prevent electrical leakage.</span></li>
                  <li><span><strong>Replacing Aging Bushings:</strong> Even the most durable bushings may degrade over time. Replacing them before they fail ensures continued safety and reliability.</span></li>
                </ul>

                <span className="rtb-h2">Final Thoughts</span>

                <p>Transformer bushings often go unnoticed, but they are essential components in power transmission systems, ensuring the safe and efficient passage of high voltage conductors while preventing electrical faults. By providing insulating materials such as resin impregnated paper (RIP), oil impregnated paper (OIP), and resin bonded paper, they enhance the dielectric strength needed to pass safely through energized systems.</p>

                <p>These bushings play a crucial role in protecting conductors from environmental influences and minimizing partial discharges, which can compromise system reliability. Used in power transformers, circuit breakers, and condenser bushings, they help maintain system stability by managing the electric field and ensuring efficient insulation with mineral oil or other dielectric fluids.</p>

                <p>Whether you're an engineer maintaining a transformer or simply interested in understanding how electricity reaches your home, it's clear that these bushings deserve significant attention for their critical role in power transmission and grid reliability.</p>

                <p>So, the next time you think of transformers and power grids, remember that little unsung hero, the humble <strong>transformer bushing</strong>, that ensures your lights stay turned on!</p>

                <p className="rtb-hashtags">#EmissionControl #CleanAir #SustainableIndustry #IndustrialSolutions #EcoFriendly<br />#transfomerbushings #transformer #sustainability</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="rtb-bottom-row">
                <div className="rtb-bottom-nav">
                  <a href="/news/upgrading-transformer-rectifier-systems" className="rtb-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/how-esp-improve-air-quality-industrial-settings" className="rtb-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="rtb-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/the-role-of-transformer-bushings-in-ensuring-safe-power-transmission/" target="blank" className="rtb-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fthe-role-of-transformer-bushings-in-ensuring-safe-power-transmission%2F&mode=login" className="rtb-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fthe-role-of-transformer-bushings-in-ensuring-safe-power-transmission%2F%26title%3DTransformer%2520Bushings%2520in%2520Safe%2520Power%2520Transmission%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fthe-role-of-transformer-bushings-in-ensuring-safe-power-transmission%2F" className="rtb-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="rtb-sidebar">

              {/* Recent Posts */}
              <div className="rtb-sidebar-block">
                <p className="rtb-sidebar-title">Recent Posts</p>
                <div className="rtb-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="rtb-recent-item">
                      <img src={post.img} alt={post.title} className="rtb-recent-img" />
                      <div className="rtb-recent-body">
                        <span className="rtb-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="rtb-sidebar-block">
                <p className="rtb-sidebar-title">Social Media</p>
                <div className="rtb-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="rtb-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="rtb-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}